export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        SAVE: async ({state}, payload) => {
            state.isSendingSAVE = true;
            payload.th.showOverlay++;
            await payload.th.$store.dispatch('SEND_POST', {
                url: '/competitors/task',
                parameter: payload.task,
                th: payload.th,
                showSuccessMessage: true,
                getSuccessResponse: () => {
                    payload.th.taskData = {
                        brand: null,
                        requestBrand: null,
                        articleModel: null,
                        region: null
                    }
                    // rewrite brand form field
                    payload.th.brandClean()
                },
                getResponse: () => {
                    state.isSendingSAVE = false;
                    payload.th.showOverlay--;
                }
            });
        },
    }
}